import moment from 'moment';
import { format, parse, isValid } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import { utcToZonedTime, format as formatTz } from 'date-fns-tz';

export default class BPCCommonHelper {
  // Field helpers
  col1 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-1 px-2': true,
      },
    },
  };
  col2 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-2 px-2': true,
      },
    },
  };
  col3 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-3 px-2': true,
      },
    },
  };
  col4 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-4 px-2': true,
      },
    },
  };
  col5 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-5 px-2': true,
      },
    },
  };
  col6 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-6 px-2': true,
      },
    },
  };
  col7 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-7 px-2': true,
      },
    },
  };
  col8 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-8 px-2': true,
      },
    },
  };
  col9 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-9 px-2': true,
      },
    },
  };
  col10 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-10 px-2': true,
      },
    },
  };
  col11 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-11 px-2': true,
      },
    },
  };
  col12 = {
    wrapperAttributes: {
      class: {
        'inline-field col-md-12 px-2': true,
      },
    },
  };

  labelCol1 = {
    labelAttributes: {
      cols: 1,
    },
  };

  labelCol2 = {
    labelAttributes: {
      cols: 2,
    },
  };
  labelCol3 = {
    labelAttributes: {
      cols: 3,
    },
  };
  labelCol4 = {
    labelAttributes: {
      cols: 4,
    },
  };
  labelCol6 = {
    labelAttributes: {
      cols: 6,
    },
  };
  labelCol7 = {
    labelAttributes: {
      cols: 7,
    },
  };
  labelCol8 = {
    labelAttributes: {
      cols: 8,
    },
  };
  labelCol9 = {
    labelAttributes: {
      cols: 9,
    },
  };
  labelCol10 = {
    labelAttributes: {
      cols: 10,
    },
  };
  labelCol11 = {
    labelAttributes: {
      cols: 11,
    },
  };
  labelCol12 = {
    labelAttributes: {
      cols: 12,
    },
  };

  get label() {
    return {
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }

  formatPrice(value, emptyIfNull = false, zeroIfNull = true) {
    return this.formatNumber(value, (emptyIfNull = false), (zeroIfNull = true)) + ' €';
  }
  formatNumber(value, emptyIfNull = false, zeroIfNull = true) {
    if (!value && emptyIfNull) {
      return '';
    }
    if (!value && zeroIfNull) {
      value = '0';
    }
    if (typeof value === 'string') {
      value = value.replace(',', '.');
    }
    // Number of decimals
    value = value + '';
    return parseFloat(value)
      .toFixed(2)
      .replace('.', ',');
  }
  FRmoneyFormat(value) {
    const options = {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
      groupingSeparator: ' ',
      decimalSeparator: ',',
    };
    const formattedNumber = value.toLocaleString('fr-FR', options);
    return formattedNumber;
  }
  /**
   * Formats a date string using the 'DD/MM/YYYY' format.
   * @param {string} date - The date string to format in 'YYYY-MM-DD' format.
   * @returns {string} A formatted date string or an empty string if the input is falsy.
   * @throws {Error} An error if the input string cannot be converted to a valid date.
   *
   * @example
   * // Returns '01/01/2022'
   * formatDateV2('2022-01-01');
   *
   * @example
   * // Throws an error for invalid input
   * formatDateV2(123);
   */
  formatDateV2(date) {
    // Check if the date is falsy or not a string, and throw an error if so.
    if (!date || typeof date !== 'string') {
      throw new Error('Invalid date input. Please provide a valid date string.');
    }
    // Attempt to convert the date string to a Date object.
    const parsedDate = new Date(date);
    // Check if the conversion to a valid date was successful.
    if (isNaN(parsedDate.getTime()) || !isValid(parsedDate)) {
      throw new Error('Invalid date');
    }
    // Format the date using the 'DD/MM/YYYY' format and return the result.
    const formattedDate = format(parsedDate, 'dd/MM/yyyy');
    return formattedDate;
  }

  /**
   * Converts a given date string to a formatted date-time string in a specified timezone.
   * Currently, it uses the 'Europe/Brussels' timezone, but this can be made dynamic in the future.
   *
   * @param {string} dateString - The input date string in the format 'yyyy-mm-ddThh:mm:ss'.
   * @returns {string} - The formatted date-time string in the 'yyyy-mm-dd HH:mm' format, adjusted to the specified timezone.
   * The reason for appending 'Z' to the dateString:
   * The 'Z' character at the end of the date string indicates that the time is in UTC (Coordinated Universal Time).
   * This ensures that the Date object interprets the input as UTC time rather than local time.
   *
   * Note: In the future, the timezone ('Europe/Brussels') can be made dynamic
   * to the function or by obtaining it from a configuration file or user input.
   */
  formatDateToTimezone(dateString) {
    // Append 'Z' to the dateString to indicate it's in UTC time.
    const UTCDate = dateString + 'Z';
    // Create a Date object from the UTC date string.
    const date = new Date(UTCDate);
    // Define the target timezone. This can be made dynamic in the future.
    const timeZone = 'Europe/Brussels';
    // Convert the Date object to the target timezone.
    const zonedDate = utcToZonedTime(date, timeZone);
    // Format the date-time string in the 'yyyy-mm-dd HH:mm' format.
    const formatedZonedDate = formatTz(zonedDate, 'yyyy-MM-dd HH:mm');
    // Return the formatted date-time string.
    return formatedZonedDate;
  }

  formatWeekday(date) {
    // Check if the date is falsy or not a string, and throw an error if so.
    if (!date || typeof date !== 'string') {
      throw new Error('Invalid date input. Please provide a valid date string.');
    }
    // Attempt to convert the date string to a Date object.
    const parsedDate = new Date(date);
    // Check if the conversion to a valid date was successful.
    if (isNaN(parsedDate.getTime()) || !isValid(parsedDate)) {
      throw new Error('Invalid date');
    }
    // get the number of the day in the week
    const dayNumber = parsedDate.getDay();
    switch (dayNumber) {
      case 0:
        return 'fields.sun.label';
      case 1:
        return 'fields.mon.label';
      case 2:
        return 'fields.tue.label';
      case 3:
        return 'fields.wed.label';
      case 4:
        return 'fields.thu.label';
      case 5:
        return 'fields.fri.label';
      case 6:
        return 'fields.sat.label';
    }
  }
  /**
   * Formats a time string using the 'HH:mm:ss' format.
   * @param {string} time - The time string to format.
   * @returns {string} A formatted time string or an empty string if the input is falsy.
   * @throws {Error} An error if the input string cannot be converted to a valid time.
   *
   * @example
   * // Returns '09:10'
   * formatTimeV2('09:10:00');
   *
   * @example
   * // Throws an error for invalid input
   * formatTimeV2('25:00:00');
   */
  formatTimeV2(time) {
    // Check if the time is falsy or not a string, and throw an error if so.
    if (!time || typeof time !== 'string') {
      throw new Error('Invalid time input. Please provide a valid time string.');
    }
    // Attempt to parse the time string to a Date object.
    const parsedTime = parse(time, 'HH:mm:ss', new Date());
    // Check if the conversion to a valid time was successful.
    if (!isValid(parsedTime)) {
      throw new Error(`Invalid time format. Received: ${time}`);
    }
    // Format the time using the 'HH:mm:ss' format and return the result.
    const formattedTime = format(parsedTime, 'HH:mm');
    return formattedTime;
  }

  formatDateTime2Time(dateTime: Date): string {
    return format(dateTime, 'HH:mm');
  }

  /**
   * Formats a date and time string using the 'DD/MM/YYYY HH:mm' format.
   * @param {string | Date | undefined | null} dateTime - The date and time to format.
   * @returns {string} A formatted date and time string or an empty string if the input is falsy.
   * @throws {Error} An error if the input string cannot be converted to a valid date and time.
   *
   * @example
   * // Returns '01/01/2022 12:30'
   * formatDateTimeV2('2022-01-01T12:30:00');
   *
   * @example
   * // Throws an error for invalid input
   * formatDateTimeV2(123);
   */
  formatDateTimeV2(dateTime) {
    // Check if the date and time is falsy, and return an empty string if so.
    if (!dateTime) {
      return '';
    }
    // Attempt to parse the date and time string to a Date object.
    const parsedDateTime = typeof dateTime === 'string' ? new Date(dateTime) : dateTime;
    // Check if the conversion to a valid date and time was successful.
    if (!parsedDateTime || isNaN(parsedDateTime.getTime()) || !isValid(parsedDateTime)) {
      throw new Error('Invalid date and time');
    }
    // Format the date and time using the 'DD/MM/YYYY HH:mm' format and return the result.
    const formattedDateTime = format(parsedDateTime, 'dd/MM/yyyy HH:mm');
    return formattedDateTime;
  }
  /**
   * Formats a date as a string using the 'YYYY-MM-DD' format.
   * @param {string | Date | undefined | null} dateTime - The date to format.
   * @returns {string} A formatted date string or an empty string if the input is falsy.
   * @throws {Error} An error if the input string cannot be converted to a valid date.
   *
   * @example
   * // Returns '2022-01-01'
   * getDateDbStrV2('2022-01-01T12:30:00');
   *
   * @example
   * // Throws an error for invalid input
   * getDateDbStrV2(123);
   */
  getDateDbStrV2(dateTime) {
    // Check if the date is falsy, and return an empty string if so.
    if (!dateTime) {
      return '';
    }
    // Attempt to parse the date string to a Date object.
    const parsedDate = typeof dateTime === 'string' ? new Date(dateTime) : dateTime;
    // Check if the conversion to a valid date was successful.
    if (!parsedDate || isNaN(parsedDate.getTime())) {
      throw new Error('Invalid date');
    }
    // Format the date using the 'YYYY-MM-DD' format and return the result.
    const formattedDate = format(parsedDate, 'yyyy-MM-dd');
    return formattedDate;
  }
  /**
   * Formats a time as a string using the 'HH:mm' format.
   * @param {string | Date | undefined | null} dateTime - The time to format.
   * @returns {string} A formatted time string or an empty string if the input is falsy.
   * @throws {Error} An error if the input string cannot be converted to a valid time.
   *
   * @example
   * // Returns '12:30'
   * getTimeDbStrV2('2022-01-01T12:30:00');
   *
   * @example
   * // Throws an error for invalid input
   * getTimeDbStrV2(123);
   */
  getTimeDbStrV2(dateTime) {
    // Check if the time is falsy, and return an empty string if so.
    if (!dateTime) {
      return '';
    }
    // Attempt to parse the time string to a Date object.
    const parsedTime = typeof dateTime === 'string' ? new Date(dateTime) : dateTime;
    // Check if the conversion to a valid time was successful.
    if (!parsedTime || isNaN(parsedTime.getTime())) {
      throw new Error('Invalid time');
    }
    // Format the time using the 'HH:mm' format and return the result.
    const formattedTime = format(parsedTime, 'HH:mm');
    return formattedTime;
  }
  /**
   * Formats a date string. (Deprecated: Use formatDateV2 instead.)
   * @param {string} date - The date string to format.
   * @returns {string} A formatted date string or an empty string if the input is falsy.
   *
   * @deprecated Use formatDateV2 instead.
   */
  formatDate(date) {
    if (!date) {
      return '';
    }
    return moment(String(date)).format('DD/MM/YYYY');
  }
  /**
   * Formats a time string. (Deprecated: Use formatTimeV2 instead.)
   * @param {string} time - The time string to format.
   * @returns {string} A formatted time string or an empty string if the input is falsy.
   *
   * @deprecated Use formatTimeV2 instead.
   */
  formatTime(time) {
    if (!time) {
      return '';
    }
    return moment(String(time)).format('HH:mm');
  }
  /**
   * Formats a date and time string. (Deprecated: Use formatDateTimeV2 instead.)
   * @param {string} dateTime - The date and time to format.
   * @returns {string} A formatted date and time string or an empty string if the input is falsy.
   *
   * @deprecated Use formatDateTimeV2 instead.
   */
  formatDateTime(dateTime) {
    if (!dateTime) {
      return '';
    }
    return moment(String(dateTime)).format('DD/MM/YYYY HH:mm');
  }
  /**
   * Formats a date as a string. (Deprecated: Use getDateDbStrV2 instead.)
   * @param {string} [dateTime=null] - The date to format.
   * @returns {string} A formatted date string or an empty string if the input is falsy.
   *
   * @deprecated Use getDateDbStrV2 instead.
   */
  getDateDbStr(dateTime = null) {
    const mDate = dateTime ? moment(dateTime) : moment();
    return mDate.format('YYYY-MM-DD');
  }
  /**
   * Formats a time as a string. (Deprecated: Use getTimeDbStrV2 instead.)
   * @param {string} [dateTime=null] - The time to format.
   * @returns {string} A formatted time string or an empty string if the input is falsy.
   *
   * @deprecated Use getTimeDbStrV2 instead.
   */
  getTimeDbStr(dateTime = null) {
    const mDate = dateTime ? moment(dateTime) : moment();
    return mDate.format('HH:mm');
  }
  dot2DoubleUnderscore(str: string): string {
    return str.replace('.', '__');
  }
  generateUUIDv4() {
    return uuidv4();
  }
  public getDisciplineIcon(discipline: string) {
    const text = discipline.toLowerCase();
    if (text.includes('tennis')) {
      return 'mdi-tennis-ball-outline';
    } else if (text.includes('padel')) {
      return 'mdi-tennis';
    } else if (text.includes('bad')) {
      return 'mdi-badminton';
    } else if (text.includes('ping') || text.includes('table')) {
      return 'mdi-table-tennis';
    } else if (text.includes('basket')) {
      return 'mdi-basketball';
    } else if (text.includes('foot')) {
      return 'mdi-soccer';
    } else if (text.includes('nat')) {
      return 'mdi-swim';
    } else if (text.includes('art') || text.includes('mart')) {
      return 'mdi-karate';
    }
    return 'mdi-tennis';
  }

  limitText(content: string, numberWords: number = 30): string {
    const div = document.createElement('div');
    div.innerHTML = content;
    let text = div.textContent || div.innerText || '';

    // Only cut if it is requested
    if (numberWords > 0) {
      text = text
        .split(' ')
        .slice(0, numberWords)
        .join(' ');
      if (text != content) {
        text += ' [...]';
      }
    }

    return text;
  }

  countryOptions() {
    return [
      {
        text: 'countries.placeholder',
        value: 'null',
      },
      {
        text: 'countries.ad',
        value: 'ad',
      },
      {
        text: 'countries.ae',
        value: 'ae',
      },
      {
        text: 'countries.af',
        value: 'af',
      },
      {
        text: 'countries.ag',
        value: 'ag',
      },
      {
        text: 'countries.ai',
        value: 'ai',
      },
      {
        text: 'countries.al',
        value: 'al',
      },
      {
        text: 'countries.am',
        value: 'am',
      },
      {
        text: 'countries.ao',
        value: 'ao',
      },
      {
        text: 'countries.aq',
        value: 'aq',
      },
      {
        text: 'countries.ar',
        value: 'ar',
      },
      {
        text: 'countries.as',
        value: 'as',
      },
      {
        text: 'countries.at',
        value: 'at',
      },
      {
        text: 'countries.au',
        value: 'au',
      },
      {
        text: 'countries.aw',
        value: 'aw',
      },
      {
        text: 'countries.ax',
        value: 'ax',
      },
      {
        text: 'countries.az',
        value: 'az',
      },
      {
        text: 'countries.ba',
        value: 'ba',
      },
      {
        text: 'countries.bb',
        value: 'bb',
      },
      {
        text: 'countries.bd',
        value: 'bd',
      },
      {
        text: 'countries.be',
        value: 'be',
      },
      {
        text: 'countries.bf',
        value: 'bf',
      },
      {
        text: 'countries.bg',
        value: 'bg',
      },
      {
        text: 'countries.bh',
        value: 'bh',
      },
      {
        text: 'countries.bi',
        value: 'bi',
      },
      {
        text: 'countries.bj',
        value: 'bj',
      },
      {
        text: 'countries.bl',
        value: 'bl',
      },
      {
        text: 'countries.bm',
        value: 'bm',
      },
      {
        text: 'countries.bn',
        value: 'bn',
      },
      {
        text: 'countries.bo',
        value: 'bo',
      },
      {
        text: 'countries.bq',
        value: 'bq',
      },
      {
        text: 'countries.br',
        value: 'br',
      },
      {
        text: 'countries.bs',
        value: 'bs',
      },
      {
        text: 'countries.bt',
        value: 'bt',
      },
      {
        text: 'countries.bv',
        value: 'bv',
      },
      {
        text: 'countries.bw',
        value: 'bw',
      },
      {
        text: 'countries.by',
        value: 'by',
      },
      {
        text: 'countries.bz',
        value: 'bz',
      },
      {
        text: 'countries.ca',
        value: 'ca',
      },
      {
        text: 'countries.cc',
        value: 'cc',
      },
      {
        text: 'countries.cd',
        value: 'cd',
      },
      {
        text: 'countries.cf',
        value: 'cf',
      },
      {
        text: 'countries.cg',
        value: 'cg',
      },
      {
        text: 'countries.ch',
        value: 'ch',
      },
      {
        text: 'countries.ci',
        value: 'ci',
      },
      {
        text: 'countries.ck',
        value: 'ck',
      },
      {
        text: 'countries.cl',
        value: 'cl',
      },
      {
        text: 'countries.cm',
        value: 'cm',
      },
      {
        text: 'countries.cn',
        value: 'cn',
      },
      {
        text: 'countries.co',
        value: 'co',
      },
      {
        text: 'countries.cr',
        value: 'cr',
      },
      {
        text: 'countries.cu',
        value: 'cu',
      },
      {
        text: 'countries.cv',
        value: 'cv',
      },
      {
        text: 'countries.cw',
        value: 'cw',
      },
      {
        text: 'countries.cx',
        value: 'cx',
      },
      {
        text: 'countries.cy',
        value: 'cy',
      },
      {
        text: 'countries.cz',
        value: 'cz',
      },
      {
        text: 'countries.de',
        value: 'de',
      },
      {
        text: 'countries.dj',
        value: 'dj',
      },
      {
        text: 'countries.dk',
        value: 'dk',
      },
      {
        text: 'countries.dm',
        value: 'dm',
      },
      {
        text: 'countries.do',
        value: 'do',
      },
      {
        text: 'countries.dz',
        value: 'dz',
      },
      {
        text: 'countries.ec',
        value: 'ec',
      },
      {
        text: 'countries.ee',
        value: 'ee',
      },
      {
        text: 'countries.eg',
        value: 'eg',
      },
      {
        text: 'countries.eh',
        value: 'eh',
      },
      {
        text: 'countries.er',
        value: 'er',
      },
      {
        text: 'countries.es',
        value: 'es',
      },
      {
        text: 'countries.et',
        value: 'et',
      },
      {
        text: 'countries.fi',
        value: 'fi',
      },
      {
        text: 'countries.fj',
        value: 'fj',
      },
      {
        text: 'countries.fk',
        value: 'fk',
      },
      {
        text: 'countries.fm',
        value: 'fm',
      },
      {
        text: 'countries.fo',
        value: 'fo',
      },
      {
        text: 'countries.fr',
        value: 'fr',
      },
      {
        text: 'countries.ga',
        value: 'ga',
      },
      {
        text: 'countries.gb',
        value: 'gb',
      },
      {
        text: 'countries.gd',
        value: 'gd',
      },
      {
        text: 'countries.ge',
        value: 'ge',
      },
      {
        text: 'countries.gf',
        value: 'gf',
      },
      {
        text: 'countries.gg',
        value: 'gg',
      },
      {
        text: 'countries.gh',
        value: 'gh',
      },
      {
        text: 'countries.gi',
        value: 'gi',
      },
      {
        text: 'countries.gl',
        value: 'gl',
      },
      {
        text: 'countries.gm',
        value: 'gm',
      },
      {
        text: 'countries.gn',
        value: 'gn',
      },
      {
        text: 'countries.gp',
        value: 'gp',
      },
      {
        text: 'countries.gq',
        value: 'gq',
      },
      {
        text: 'countries.gr',
        value: 'gr',
      },
      {
        text: 'countries.gs',
        value: 'gs',
      },
      {
        text: 'countries.gt',
        value: 'gt',
      },
      {
        text: 'countries.gu',
        value: 'gu',
      },
      {
        text: 'countries.gw',
        value: 'gw',
      },
      {
        text: 'countries.gy',
        value: 'gy',
      },
      {
        text: 'countries.hk',
        value: 'hk',
      },
      {
        text: 'countries.hm',
        value: 'hm',
      },
      {
        text: 'countries.hn',
        value: 'hn',
      },
      {
        text: 'countries.hr',
        value: 'hr',
      },
      {
        text: 'countries.ht',
        value: 'ht',
      },
      {
        text: 'countries.hu',
        value: 'hu',
      },
      {
        text: 'countries.id',
        value: 'id',
      },
      {
        text: 'countries.ie',
        value: 'ie',
      },
      {
        text: 'countries.il',
        value: 'il',
      },
      {
        text: 'countries.im',
        value: 'im',
      },
      {
        text: 'countries.in',
        value: 'in',
      },
      {
        text: 'countries.io',
        value: 'io',
      },
      {
        text: 'countries.iq',
        value: 'iq',
      },
      {
        text: 'countries.ir',
        value: 'ir',
      },
      {
        text: 'countries.is',
        value: 'is',
      },
      {
        text: 'countries.it',
        value: 'it',
      },
      {
        text: 'countries.je',
        value: 'je',
      },
      {
        text: 'countries.jm',
        value: 'jm',
      },
      {
        text: 'countries.jo',
        value: 'jo',
      },
      {
        text: 'countries.jp',
        value: 'jp',
      },
      {
        text: 'countries.ke',
        value: 'ke',
      },
      {
        text: 'countries.kg',
        value: 'kg',
      },
      {
        text: 'countries.kh',
        value: 'kh',
      },
      {
        text: 'countries.ki',
        value: 'ki',
      },
      {
        text: 'countries.km',
        value: 'km',
      },
      {
        text: 'countries.kn',
        value: 'kn',
      },
      {
        text: 'countries.kp',
        value: 'kp',
      },
      {
        text: 'countries.kr',
        value: 'kr',
      },
      {
        text: 'countries.kw',
        value: 'kw',
      },
      {
        text: 'countries.ky',
        value: 'ky',
      },
      {
        text: 'countries.kz',
        value: 'kz',
      },
      {
        text: 'countries.la',
        value: 'la',
      },
      {
        text: 'countries.lb',
        value: 'lb',
      },
      {
        text: 'countries.lc',
        value: 'lc',
      },
      {
        text: 'countries.li',
        value: 'li',
      },
      {
        text: 'countries.lk',
        value: 'lk',
      },
      {
        text: 'countries.lr',
        value: 'lr',
      },
      {
        text: 'countries.ls',
        value: 'ls',
      },
      {
        text: 'countries.lt',
        value: 'lt',
      },
      {
        text: 'countries.lu',
        value: 'lu',
      },
      {
        text: 'countries.lv',
        value: 'lv',
      },
      {
        text: 'countries.ly',
        value: 'ly',
      },
      {
        text: 'countries.ma',
        value: 'ma',
      },
      {
        text: 'countries.mc',
        value: 'mc',
      },
      {
        text: 'countries.md',
        value: 'md',
      },
      {
        text: 'countries.me',
        value: 'me',
      },
      {
        text: 'countries.mf',
        value: 'mf',
      },
      {
        text: 'countries.mg',
        value: 'mg',
      },
      {
        text: 'countries.mh',
        value: 'mh',
      },
      {
        text: 'countries.mk',
        value: 'mk',
      },
      {
        text: 'countries.ml',
        value: 'ml',
      },
      {
        text: 'countries.mm',
        value: 'mm',
      },
      {
        text: 'countries.mn',
        value: 'mn',
      },
      {
        text: 'countries.mo',
        value: 'mo',
      },
      {
        text: 'countries.mp',
        value: 'mp',
      },
      {
        text: 'countries.mq',
        value: 'mq',
      },
      {
        text: 'countries.mr',
        value: 'mr',
      },
      {
        text: 'countries.ms',
        value: 'ms',
      },
      {
        text: 'countries.mt',
        value: 'mt',
      },
      {
        text: 'countries.mu',
        value: 'mu',
      },
      {
        text: 'countries.mv',
        value: 'mv',
      },
      {
        text: 'countries.mw',
        value: 'mw',
      },
      {
        text: 'countries.mx',
        value: 'mx',
      },
      {
        text: 'countries.my',
        value: 'my',
      },
      {
        text: 'countries.mz',
        value: 'mz',
      },
      {
        text: 'countries.na',
        value: 'na',
      },
      {
        text: 'countries.nc',
        value: 'nc',
      },
      {
        text: 'countries.ne',
        value: 'ne',
      },
      {
        text: 'countries.nf',
        value: 'nf',
      },
      {
        text: 'countries.ng',
        value: 'ng',
      },
      {
        text: 'countries.ni',
        value: 'ni',
      },
      {
        text: 'countries.nl',
        value: 'nl',
      },
      {
        text: 'countries.no',
        value: 'no',
      },
      {
        text: 'countries.np',
        value: 'np',
      },
      {
        text: 'countries.nr',
        value: 'nr',
      },
      {
        text: 'countries.nu',
        value: 'nu',
      },
      {
        text: 'countries.nz',
        value: 'nz',
      },
      {
        text: 'countries.om',
        value: 'om',
      },
      {
        text: 'countries.pa',
        value: 'pa',
      },
      {
        text: 'countries.pe',
        value: 'pe',
      },
      {
        text: 'countries.pf',
        value: 'pf',
      },
      {
        text: 'countries.pg',
        value: 'pg',
      },
      {
        text: 'countries.ph',
        value: 'ph',
      },
      {
        text: 'countries.pk',
        value: 'pk',
      },
      {
        text: 'countries.pl',
        value: 'pl',
      },
      {
        text: 'countries.pm',
        value: 'pm',
      },
      {
        text: 'countries.pn',
        value: 'pn',
      },
      {
        text: 'countries.pr',
        value: 'pr',
      },
      {
        text: 'countries.ps',
        value: 'ps',
      },
      {
        text: 'countries.pt',
        value: 'pt',
      },
      {
        text: 'countries.pw',
        value: 'pw',
      },
      {
        text: 'countries.py',
        value: 'py',
      },
      {
        text: 'countries.qa',
        value: 'qa',
      },
      {
        text: 'countries.re',
        value: 're',
      },
      {
        text: 'countries.ro',
        value: 'ro',
      },
      {
        text: 'countries.rs',
        value: 'rs',
      },
      {
        text: 'countries.ru',
        value: 'ru',
      },
      {
        text: 'countries.rw',
        value: 'rw',
      },
      {
        text: 'countries.sa',
        value: 'sa',
      },
      {
        text: 'countries.sb',
        value: 'sb',
      },
      {
        text: 'countries.sc',
        value: 'sc',
      },
      {
        text: 'countries.sd',
        value: 'sd',
      },
      {
        text: 'countries.se',
        value: 'se',
      },
      {
        text: 'countries.sg',
        value: 'sg',
      },
      {
        text: 'countries.sh',
        value: 'sh',
      },
      {
        text: 'countries.si',
        value: 'si',
      },
      {
        text: 'countries.sj',
        value: 'sj',
      },
      {
        text: 'countries.sk',
        value: 'sk',
      },
      {
        text: 'countries.sl',
        value: 'sl',
      },
      {
        text: 'countries.sm',
        value: 'sm',
      },
      {
        text: 'countries.sn',
        value: 'sn',
      },
      {
        text: 'countries.so',
        value: 'so',
      },
      {
        text: 'countries.sr',
        value: 'sr',
      },
      {
        text: 'countries.ss',
        value: 'ss',
      },
      {
        text: 'countries.st',
        value: 'st',
      },
      {
        text: 'countries.sv',
        value: 'sv',
      },
      {
        text: 'countries.sx',
        value: 'sx',
      },
      {
        text: 'countries.sy',
        value: 'sy',
      },
      {
        text: 'countries.sz',
        value: 'sz',
      },
      {
        text: 'countries.tc',
        value: 'tc',
      },
      {
        text: 'countries.td',
        value: 'td',
      },
      {
        text: 'countries.tf',
        value: 'tf',
      },
      {
        text: 'countries.tg',
        value: 'tg',
      },
      {
        text: 'countries.th',
        value: 'th',
      },
      {
        text: 'countries.tj',
        value: 'tj',
      },
      {
        text: 'countries.tk',
        value: 'tk',
      },
      {
        text: 'countries.tl',
        value: 'tl',
      },
      {
        text: 'countries.tm',
        value: 'tm',
      },
      {
        text: 'countries.tn',
        value: 'tn',
      },
      {
        text: 'countries.to',
        value: 'to',
      },
      {
        text: 'countries.tr',
        value: 'tr',
      },
      {
        text: 'countries.tt',
        value: 'tt',
      },
      {
        text: 'countries.tv',
        value: 'tv',
      },
      {
        text: 'countries.tw',
        value: 'tw',
      },
      {
        text: 'countries.tz',
        value: 'tz',
      },
      {
        text: 'countries.ua',
        value: 'ua',
      },
      {
        text: 'countries.ug',
        value: 'ug',
      },
      {
        text: 'countries.um',
        value: 'um',
      },
      {
        text: 'countries.us',
        value: 'us',
      },
      {
        text: 'countries.uy',
        value: 'uy',
      },
      {
        text: 'countries.uz',
        value: 'uz',
      },
      {
        text: 'countries.va',
        value: 'va',
      },
      {
        text: 'countries.vc',
        value: 'vc',
      },
      {
        text: 'countries.ve',
        value: 've',
      },
      {
        text: 'countries.vg',
        value: 'vg',
      },
      {
        text: 'countries.vi',
        value: 'vi',
      },
      {
        text: 'countries.vn',
        value: 'vn',
      },
      {
        text: 'countries.vu',
        value: 'vu',
      },
      {
        text: 'countries.wf',
        value: 'wf',
      },
      {
        text: 'countries.ws',
        value: 'ws',
      },
      {
        text: 'countries.xk',
        value: 'xk',
      },
      {
        text: 'countries.ye',
        value: 'ye',
      },
      {
        text: 'countries.yt',
        value: 'yt',
      },
      {
        text: 'countries.za',
        value: 'za',
      },
      {
        text: 'countries.zm',
        value: 'zm',
      },
      {
        text: 'countries.zw',
        value: 'zw',
      },
      {
        text: 'countries.other',
        value: 'other',
      },
    ];
  }
}

export const useCommonHelper = (): BPCCommonHelper => {
  return new BPCCommonHelper();
};
